/**
 * Create a Marionette view that contains a React component and mount/unmount
 * it as appropriate in `onShow`/`onDestroy`.
 *
 *  Marionette.View.extend(ReactComponentView).extend({
 *    getReactComponent: function() {
 *      return React.createElement(Component, {...props});
 *    }
 *  });
 *
 */
var ReactDOM = require('react-dom');

module.exports = {
    template: false,

    onShow: function() {
        if (this._reactMountEl) {
            ReactDOM.unmountComponentAtNode(this._reactMountEl);
        }

        this._reactMountEl = this.el;
        var component = this.getReactComponent();
        ReactDOM.render(component, this._reactMountEl);
    },

    onDestroy: function() {
        if (this._reactMountEl) {
            ReactDOM.unmountComponentAtNode(this._reactMountEl);
        }
    },
};
